import React from "react";
import IngredientTypeList from "./ingredientTypeList";
import {IngredientTypeData} from "./ingredientType";
import InsertHTMLTyped from "./insertHTMLTypes";

/**
 *
 */
export type IngredientData = {
    id : string
    name : string
    translation : string
    description : string
    source : string
    types : IngredientTypeData[]
    proportion ?: string
};

/**
 *
 */
type Data = {
    ingredient : IngredientData
};

/**
 *
 * @param ingredient
 * @constructor
 */
export default function Ingredient ({ ingredient } : Data) {
    // init
    const itemId = 'ingredient-id-' + ingredient.id;
    const collapsedId = 'ingredient-collapsed-id-' + ingredient.id;

    // render 
    return (
        <div className="accordion-item bg-light">
            <h3 className="accordion-header" id={itemId}>
                <button className="accordion-button collapsed bg-light p-1 ps-0 pe-0 pt-2 pb-2 border-0 shadow-none" type="button" data-bs-toggle="collapse"
                        data-bs-target={'#' + collapsedId} aria-expanded="false" aria-controls={collapsedId}>
                    {/*<Emoji size={'small'} trafficLight={ingredient.trafficLight} />
                    <span className="ms-1">{ingredient.translation}</span>*/}
                    <div className={'row w-100'}>
                        <div className={ingredient.proportion ? 'col-7 col-md-5' : ''}>{ingredient.translation}</div>
                        {ingredient.proportion ? <div className={'col-4 col-md-3 text-end'}>{ingredient.proportion} %</div> : ''}
                    </div>
                </button>
                <div className={'fs-6 p-0 mb-2 mt-1'}>
                    <IngredientTypeList
                        id={'ingredient-' + ingredient.id}
                        singular={true}
                        ingredientTypes={ingredient.types}
                    />
                </div>
            </h3>
            <div id={collapsedId} className="accordion-collapse collapse" aria-labelledby={itemId}
                 data-bs-parent="#ingredientList">
                <div className="accordion-body p-1 mb-1">
                    {/*<p>*/}
                    {/*    {ingredient.description}<br />*/}
                    {/*    /!*<small className={'fst-italic'}>{ingredient.source}</small>*!/*/}
                    {/*</p>*/}
                    <InsertHTMLTyped content={ingredient.description} style={''} />
                </div>
            </div>
        </div>
    );
}